<template>
  <svg xmlns="http://www.w3.org/2000/svg"
       :width="width"
       :height="height"
       viewBox="0 0 52 52"
       @click="$emit('click')">
    <transition name="fade">
      <path v-if="active" key="active" :fill="iconColor" d="M26 52C11.64 52 0 40.36 0 26S11.64 0 26 0s26 11.64 26 26-11.64 26-26 26zm7.708-18.49c1.728 1.564 3.11 2.49 3.11 2.49s9.818-6.577 9.818-14.288c0-5.364-4.395-9.712-9.818-9.712a9.847 9.847 0 0 0-5.609 1.74 14.56 14.56 0 0 1 3.7 4.85 4 4 0 1 1 1.326 7.337c-.21 2.548-1.092 5.085-2.527 7.582zM20.766 45s13.766-9.317 13.766-20.241C34.532 17.16 28.368 11 20.766 11 13.163 11 7 17.16 7 24.759 7 35.683 20.766 45 20.766 45zm.118-29.564c.27.021.54.043.809.075 9.303 1.08 8.415 10.181 8.415 10.181-5.591 0-9.24-2.776-9.24-2.776.142 1.205 1.232 1.866 1.232 1.866-3.53 0-4.63-2.703-4.63-2.703-1.098 3.504-5.6 3.613-5.6 3.613 0-9.468 5.355-8.117 4.156-9.6a2.142 2.142 0 0 0-.597-.493l-.134-.077a5.093 5.093 0 0 1 1.03-.12c.675 0 .967.197 1.037.286 0-1.228 1.208-1.488 1.208-1.488 0 .954 1.633 1.182 2.314 1.236zm3.705 10.754c1.342.48 2.963.872 4.806.969-.959 3.977-4.296 6.912-8.268 6.912-3.993 0-7.347-2.968-8.284-6.98a9.019 9.019 0 0 0 1.893-.519c1.274-.51 2.285-1.284 2.992-2.281.872.94 2.3 1.899 4.504 1.899h2.357z"/>
      <path v-else key="default" :fill="iconColor" d="M26 52C11.64 52 0 40.36 0 26S11.64 0 26 0s26 11.64 26 26-11.64 26-26 26zm0-1.962c13.276 0 24.038-10.762 24.038-24.038S39.276 1.962 26 1.962 1.962 12.724 1.962 26 12.724 50.038 26 50.038zm7.708-16.529c1.435-2.497 2.317-5.034 2.526-7.582a4 4 0 1 0-1.326-7.337 14.56 14.56 0 0 0-3.699-4.85A9.847 9.847 0 0 1 36.82 12c5.422 0 9.817 4.348 9.817 9.712 0 7.711-9.818 14.288-9.818 14.288s-1.382-.926-3.11-2.49zM20.766 45S7 35.683 7 24.759C7 17.16 13.163 11 20.766 11c7.602 0 13.766 6.16 13.766 13.759C34.532 35.683 20.766 45 20.766 45zm.118-29.564c-.68-.054-2.314-.282-2.314-1.236 0 0-1.208.26-1.208 1.488-.07-.09-.362-.285-1.037-.285-.276 0-.616.032-1.03.119l.134.077c.224.13.433.291.597.493 1.2 1.483-4.156.132-4.156 9.6 0 0 4.502-.11 5.6-3.613 0 0 1.1 2.703 4.63 2.703 0 0-1.09-.661-1.232-1.866 0 0 3.649 2.776 9.24 2.776 0 0 .888-9.101-8.415-10.181-.27-.032-.54-.054-.81-.075zm3.705 10.754h-2.357c-2.203 0-3.632-.959-4.504-1.9-.707.998-1.718 1.772-2.992 2.282a9.019 9.019 0 0 1-1.893.52c.937 4.01 4.29 6.98 8.284 6.98 3.972 0 7.31-2.936 8.268-6.913a16.898 16.898 0 0 1-4.806-.969z"/>
    </transition>
  </svg>
</template>

<script>
  import iconMixin from './iconMixin.js'

  export default {
    props: {
      active: {
        required: false,
        type: Boolean,
        default: false
      }
    },

    mixins: [iconMixin]
  }
</script>

<style lang="scss" scoped>
  .fade-enter-active,
  .fade-leave-active {
    transition: opacity .1s ease-out;
  }

  .fade-enter,
  .fade-leave-to {
    opacity: 0;
  }
</style>
